import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import ResourceSelector from '../simpletons/ResourceSelector'

export default function RoleField ({ children }) {
  return (
    <ResourceSelector
      name='role_id'
      resourceName='permissions.roles'
      optionsKey='translated_name'
      label={<Translation name='fields.role_id.label' />}
    />
  )
}
